import React from 'react'
import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'
import { useDiscoverStore } from '../stores/discover-store'

interface SearchBarProps {
  className?: string
}

export function SearchBar({ className }: SearchBarProps) {
  const { searchQuery } = useDiscoverStore((s) => s.searchParams)
  const { setSearchQuery } = useDiscoverStore((s) => s.searchParams)
  const { handleExecuteSearch } = useDiscoverStore((s) => s.handlers)

  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleExecuteSearch((e.target as HTMLInputElement).value)
    }
  }
  return (
    <div className={cn('relative', className)}>
      <Search className='text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2' />
      <Input
        placeholder='搜索...'
        className='bg-muted/50 w-full border-none pl-9 text-base focus-visible:ring-0 focus-visible:ring-offset-0'
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={handleSearchKeyDown}
      />
    </div>
  )
}
